import { render } from "./AppBar.vue?vue&type=template&id=a45eb10c&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=a45eb10c&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45eb10c"]])

export default __exports__